import { useMemo } from 'react';
import moment from 'moment-timezone';
import { timeZones } from 'const';

export default () => {
  const tZOptions = useMemo(
    () =>
      moment.tz
        .names()
        .filter((z) => timeZones.includes(z))
        .sort(),
    [],
  );
  return { data: tZOptions };
};
